import * as React from 'react';
import { Layer } from 'react-map-gl';

import { ILoaderProps } from '../../layer/ILoaderProps';
import { LoadableSource } from '../../layer/LoadableSource';
import { Config } from '../../../Config';

const RoadsCentral = (props: ILoaderProps) => {
  return (
    <LoadableSource path="https://apigeostore.longline.co.uk/dataset/16cb756379d043cf37a5368a1f2c94c6afb98e6e" {...props}>
      <Layer
        id='roads_central'
        beforeId={Config.UI.before_layer}
        type="line"
        layout={{ visibility: props.active ? "visible" : "none" }}          
        paint={{ 
          "line-color": "white",
          "line-width": [
            'interpolate',
            ['linear'],
            ["zoom"],
            0, 3,
            8, 5,
            18, 13
          ],
        }}        
      />
      <Layer
        beforeId={Config.UI.before_layer}
        type="line"
        layout={{ visibility: props.active ? "visible" : "none" }}          
        paint={{ 
          "line-color": "#555",
          "line-width": [
            'interpolate',
            ['linear'],
            ["zoom"],
            0, 1,
            8, 2,
            18, 10
          ],
        }}
      />

    </LoadableSource>
  );
}

export { RoadsCentral }
